import { Reveal, Stagger, StaggerItem } from "../common/Reveal";
import { SectionHeading } from "../common/SectionHeading";
import { CTAButton } from "../common/CTAButton";
import { aboutFocus, images } from "../../data/content";
import { CheckCircle } from "@phosphor-icons/react";

export const AboutManifesto = ({ withCta = true }) => (
    <section className="relative bg-white grain" data-testid="about-manifesto">
        <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-24 lg:py-32">
            <div className="grid lg:grid-cols-12 gap-14 items-start">
                <div className="lg:col-span-6">
                    <SectionHeading
                        overline="About FRONTX"
                        title="Building Workforce. Delivering Projects. Creating Impact."
                        subtitle="FRONTX Integrated Services India Private Limited is a professionally managed manpower, staffing, workforce management and construction services company serving organizations across India."
                    />
                    <div className="mt-6 space-y-4 text-slate-600 leading-relaxed max-w-2xl">
                        <p>We specialize in providing reliable manpower solutions for short-term, long-term, project-based, contractual and bulk workforce requirements.</p>
                        <p>Alongside manpower services, FRONTX also provides construction and allied project execution services, enabling organizations to work with a single integrated service partner.</p>
                    </div>
                    {withCta && (
                        <div className="mt-8 flex flex-wrap gap-4">
                            <CTAButton to="/about" variant="outlineNavy">Read More About Us</CTAButton>
                            <CTAButton to="/contact#manpower" variant="primary">Request Manpower</CTAButton>
                        </div>
                    )}
                </div>

                <div className="lg:col-span-6">
                    <Reveal>
                        <div className="relative">
                            <div className="absolute -top-4 -left-4 h-24 w-24 border-t-2 border-l-2 border-brand" />
                            <img src={images.officeTeam} alt="FRONTX professional workforce" className="w-full h-[320px] lg:h-[380px] object-cover rounded-sm grayscale-[15%]" />
                            <div className="absolute -bottom-6 -right-4 bg-navy text-white p-6 rounded-sm max-w-[240px] shadow-xl">
                                <div className="text-xs uppercase tracking-[0.2em] text-brand font-semibold">Our Focus</div>
                                <div className="mt-2 font-display font-bold text-lg leading-tight">One integrated partner for workforce & projects</div>
                            </div>
                        </div>
                    </Reveal>
                    <Stagger className="mt-14 grid sm:grid-cols-2 gap-x-6 gap-y-3">
                        {aboutFocus.map((f) => (
                            <StaggerItem key={f} className="flex items-center gap-3 py-2 border-b border-slate-100">
                                <CheckCircle size={20} weight="fill" className="text-brand shrink-0" />
                                <span className="text-sm text-navy font-medium">{f}</span>
                            </StaggerItem>
                        ))}
                    </Stagger>
                </div>
            </div>
        </div>
    </section>
);
